<template>
  <div>
    <router-view v-if='!loading' id='appContainer'></router-view>
  </div>
</template>

<script>
  import {
    webAuth
  } from '../src/auth/index'
  import {
    aaPubnub
  } from '../src/lib/pubnub/index'
  import {
    subscriber,
    listener
  } from '@/lib/pubnub/pubnubListeners'

  export default {
    name: 'app',
    data() {
      return {
        pnInstance: null,
        loading: true,
        InboxCount: 0,
        MessagesCount: 0,
        ProcessesCount: 0
      }
    },
    created() {
      let vm = this;
      if (!window.isPlugin) {
        webAuth.login().then(function (response) {
          let oidcUser = response;
          vm.$http.get('/message/vendor').then(function (response) {
            let vendorInfo = response.data.Data
            vm.pnInstance = aaPubnub.getInstance();
            vm.pnInstance.setVendorInfo(vendorInfo);
            vm.pnInstance.setupPubnub(vendorInfo, oidcUser.ES_StaffID);
            vm.pnInstance.pubnub.addListener(listener(vendorInfo, vm));
            vm.pnInstance.pubnub.subscribe(subscriber(vendorInfo, vm));
            vm.$http.get('/account/currentUser').then(function (resp) {
              let user = resp.data.Data;
              vm.$store.dispatch('setCurrentUser', user)

              if(user && user.FeatureFlags == 2) {
                vm.$router.replace({name: 'Splash'})
              }
              // vm.$http.get('users/appbundle').then(function (resp) {
              //   if (resp.data && resp.data.Data) {
              //     vm.InboxCount = resp.data.Data.TotalBadgeCount
              //     vm.MessagesCount = resp.data.Data.TotalMessageCount
              //     vm.Processes = resp.data.Data.TotalRequestCount
              //   }
              // })
              vm.loading = false;
            })
          })
        })
      } else {
        vm.loading = false;
      }
    }
  }

</script>

<style lang='scss'>
  @import './styles/variables.scss';
  span.pandoconnect-pill {
    color: $blue-lt;
    font-weight: 500;
    border: 2px solid $blue-lt;
    border-radius: 10px;
    padding: 4px 8px;
    background: $white;
    font-size: 14px;
  }

  div.infopanel-subhead {
    color: $gray-md;
    font-weight: 500;
    font-size: 12px;
  }

  .unstyled-link {
    text-decoration: none !important;
  }

  .actionable {
    cursor: pointer;
  }

  #appContainer {
    min-width: 100%;
  }

  .flip-90 {
    transform: rotate(90deg)
  }

  .flip-180 {
    transform: rotate(180deg)
  }

  .flip-270 {
    transform: rotate(270deg)
  }

</style>



// WEBPACK FOOTER //
// src/App.vue